import { createAsyncThunk } from '@reduxjs/toolkit';
import { optionService } from '../../services';

const findAllOption = () => createAsyncThunk('options/findAll', async (categoryId: string) => optionService.findAll(categoryId));
const findAllOptionWithSuboption = () =>
  createAsyncThunk('options/findAllOptionWithSuboption', async (categoryId: string) => optionService.findAllWithSuboption(categoryId));

export default {
  findAllOption: findAllOption(),
  findAllOptionWithSuboption: findAllOptionWithSuboption(),
};
